import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getBrandAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/brand', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getBrandById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/brand/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createBrand = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/brand`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateBrand = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/brand/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteBrand = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/brand/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteBrand = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/brand/${id}`);
    return handleResponse(response, onSuccess, onError);
};